import { ErrorsLimitCca } from '@/shared/cca/errors/cca.error';

export const CCA_TRANSACTION_AMOUNT_LIMIT = 7000000;

export const CCA_DEFAULT_ERROR_REASON = 'ELAPSED_TIME_NOT_COMPLETED_CCA';

export const CCA_ERROR_TYPES = {
  AMOUNT_EXCEEDED_FIRST_TRANSFER_CCA: {
    type: 'error',
    title: ErrorsLimitCca['AMOUNT_EXCEEDED_FIRST_TRANSFER_CCA'],
    description:
      'Después de 24 horas de haber realizado un primer envío, puedes enviar hasta $7.000.000 CLP en una única operación',
    primaryText: 'Elegir otro contacto',
  },
  ELAPSED_TIME_NOT_COMPLETED_CCA: {
    type: 'error',
    title: ErrorsLimitCca['ELAPSED_TIME_NOT_COMPLETED_CCA'],
    description:
      'Por ser un contacto nuevo debes esperar 24h para volver a enviar dinero a este contacto.',
    primaryText: 'Elegir otro contacto',
  },
  DEFAULT: {
    type: 'error',
    title: 'Ocurrió un error al validar el destinatario CCA',
    description: 'Por favor, intenta nuevamente más tarde',
  },
} as const;
